<template>
    <div @click.left="leftBtnClbk($event)" @contextmenu.prevent="CMClbk($event)">
        <div>
            <button style="margin: 1.5% 0% 0% 3%;" @click="this.showNewDir = true"
                class="btn btn-outline-primary">Создать
                папку</button>
            <button style="margin: 1.5% 0% 0% 1.5%;" @click="this.showUpload = true"
                class="btn btn-outline-primary">Загрузить</button>
            <button style="margin: 1.5% 0% 0% 1.5%;" @click="this.showShares = true; getShares()"
                class="btn btn-outline-primary">Расшаренные объекты</button>
        </div>
        <h2 style="margin-top: 1.5%;">
            <h2 v-if="!(path == '/')" style="margin: 0.5% 3% 0.5% 3%;"><a @click="toNewDir('../')" href="#">../</a></h2>
            <h2 v-for="dir in dirs" :key="dir" style="margin: 0.5% 3% 0.5% 3%;">
                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#FBBB19" class="bi bi-folder-fill"
                    viewBox="0 0 16 16">
                    <path
                        d="M9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.825a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31L.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3zm-8.322.12C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139z" />
                </svg>
                <span style="padding-inline-start: 1%;">
                    <a class="file" href="#" @click="toNewDir(dir)">
                        {{ dir }}
                    </a>
                </span>
            </h2>
            <h2 v-for="file in files" :key="file" style="margin: 0.5% 3% 0.5% 3%;">
                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="35" fill="currentColor"
                    class="bi bi-file-earmark" viewBox="0 0 16 18">
                    <path
                        d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z" />
                </svg>
                <span style="padding-inline-start: 1%;">
                    <a class="file" :href="dwld_file + path + file">
                        {{ file }}
                    </a>
                </span>
            </h2>
        </h2>

        <div v-if="showUpload" class="modal fade show" tabindex="-1" aria-labelledby="exampleModalLabel"
            aria-modal="true" role="dialog" style="display:block">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Загрузка файлов на сервер</h5>
                        <button @click="showUpload = false; invalid = []" type="button" class="btn-close"
                            data-bs-dismiss="modal" aria-label="Закрыть"></button>
                    </div>
                    <form id="uploadForm" :action="upload_file" method="POST" enctype="multipart/form-data">
                        <div class="modal-body">
                            <div class="input-group">
                                <input :class="'form-control ' + (!!~invalid.indexOf('files') ? 'is-invalid' : '')"
                                    ref="file" type="file" id="formFileMultiple file files" name="files"
                                    aria-describedby="inputGroupFileAddon04" aria-label="Загрузка" multiple>
                                <div id="validationServerFilesFeedback" class="invalid-feedback">
                                    Прикрепите файлы
                                </div>
                            </div>
                        </div>
                        <!-- <div class="progress">
                        <div class="progress-bar progress-bar-striped bg-success" role="progressbar" aria-valuenow="0"
                            aria-valuemin="0" aria-valuemax="100"></div>
                    </div> -->
                        <div class="modal-footer">
                            <button @click.prevent="UploadFile" type="submit" class="btn btn-primary"
                                id="f_sub">Загрузить</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div v-if="showNewDir" class="modal fade show" tabindex="-1" aria-labelledby="exampleModalLabel"
            aria-modal="true" role="dialog" style="display:block">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Создать новую папку</h5>
                        <button @click="showNewDir = false; invalid = []" type="button" class="btn-close"
                            data-bs-dismiss="modal" aria-label="Закрыть"></button>
                    </div>
                    <div :key="dir_key" class="modal-body">
                        <div class="input-group mb-3">
                            <input type="text"
                                :class="'form-control ' + (!!~invalid.indexOf('dir_name') ? 'is-invalid' : '')"
                                id="dir_name" ref="dir_name" placeholder="Имя папки" aria-label="Имя папки"
                                aria-describedby="basic-addon1">
                            <div id="validationServerUsernameFeedback" class="invalid-feedback">
                                Введите название папки
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="createNewDir" type="submit" class="btn btn-primary" id="nd_sub">Создать</button>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="showShareLink" class="modal fade show" tabindex="-1" aria-labelledby="exampleModalLabel"
            aria-modal="true" role="dialog" style="display:block">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Ссылка на скачивание</h5>
                        <button @click="showShareLink = false; invalid = []" type="button" class="btn-close"
                            data-bs-dismiss="modal" aria-label="Закрыть"></button>
                    </div>
                    <div class="modal-body">
                        <div class="input-group mb-3">
                            <input type="text" :class="'form-control ' + (!!~invalid.indexOf('link') ? 'is-valid' : '')"
                                :value="share_link" aria-describedby="button-addon1">
                            <button @click="copyLink($event, -1, '')" class="btn btn-outline-secondary" type="button"
                                id="button-addon1">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                    class="bi bi-copy" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd"
                                        d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V2Zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H6ZM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1H2Z" />
                                </svg>
                            </button>
                            <div id="validationServerLinkFeedback" class="valid-feedback">
                                Скопировано!
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="showShares" class="modal fade show" tabindex="-1" aria-labelledby="exampleModalLabel"
            aria-modal="true" role="dialog" style="display:block">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Ссылки на скачивание, созданные ранее</h5>
                        <button @click="showShares = false" type="button" class="btn-close" data-bs-dismiss="modal"
                            aria-label="Закрыть"></button>
                    </div>
                    <div class="modal-body">
                        <div v-for="(link, index) in links" :key="index"
                            style="border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);">
                            <h5><b>{{ index + 1 }}. </b>{{ names[index] }}:</h5>
                            <div class="input-group mb-3">
                                <input type="text"
                                    :class="'form-control ' + (!!~invalid.indexOf('link' + index) ? 'is-valid' : '')"
                                    :value="link" aria-describedby="button-addon1" readonly>
                                <button @click="copyLink($event, index, link)" class="btn btn-outline-secondary"
                                    type="button" id="button-addon1">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                        class="bi bi-copy" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd"
                                            d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V2Zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H6ZM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1H2Z" />
                                    </svg>
                                </button>
                                <div id="validationServerLinkFeedback" class="valid-feedback">
                                    Скопировано!
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <ul v-if="cmShow" :style="'top:' + cmY + 'px;left:' + cmX + 'px;'" class='custom-menu' id="cm">
            <li id="share" data-action="share">Поделиться</li>
            <li id="delete" data-action="delete">Удалить</li>
        </ul>
    </div>
</template>

<script>
export default {
    name: "FileMGR",
    props: {
        username: String
    },
    data() {
        return {
            dirs: [],
            files: [],
            links: [],
            names: [],
            path: "/",
            dwld_file: "https://api.bormart.ru/file/download?name=",
            upload_file: "https://api.bormart.ru/file/upload-file",
            get_dir: "https://api.bormart.ru/filemgr?",
            create_dir: "https://api.bormart.ru/new_dir",
            del_dir: "https://api.bormart.ru/del_dir",
            share_dir: "https://api.bormart.ru/share",
            shares_get: "https://api.bormart.ru/sharefs",
            showUpload: false,
            showNewDir: false,
            showShareLink: false,
            showShares: false,
            validation: false,
            invalid: [],
            share_link: '',
            cmShow: false,
            cmX: 0,
            cmY: 0,
            cmPath: ''
        }
    },
    methods: {
        getShares() {
            fetch(this.shares_get, {
                method: "GET",
                credentials: "include",
                headers: {
                    "Content-type": "application/x-www-form-urlencoded"
                }
            }).then((response) => {
                return response.json()
            }).then((data) => {
                if (data['ok'] == 1) {
                    this.links = data['links']
                    this.names = data['names']
                }
            })
        },
        copyLink(e, i, l) {
            if (l == '') {
                l = this.share_link
            }
            navigator.clipboard.writeText(l).then(
                () => {
                    if (i == -1) {
                        this.invalid.push('link')
                    } else {
                        this.invalid.push('link' + String(i))
                    }
                })
        },
        CMClbk(e) {
            if (e.target.className === "file") {
                this.cmX = e.pageX
                this.cmY = e.pageY
                this.cmPath = e.target.firstChild.data
                this.cmShow = true
            } else {
                this.cmShow = false
            }
        },
        leftBtnClbk(e) {
            if (e.target.id == 'share') {
                fetch(this.share_dir, {
                    method: "POST",
                    credentials: "include",
                    headers: {
                        "Content-type": "application/json"
                    },
                    body: JSON.stringify({
                        "path": this.path + this.cmPath
                    })
                }).then((response) => {
                    return response.json()
                }).then((data) => {
                    if (data['ok'] == 1) {
                        this.cmShow = false
                        this.share_link = data['link']
                        this.showShareLink = true
                    }
                })
            } else if (e.target.id == 'delete') {
                fetch(this.del_dir, {
                    method: "POST",
                    credentials: "include",
                    headers: {
                        "Content-type": "application/json"
                    },
                    body: JSON.stringify({
                        "path": this.path + this.cmPath
                    })
                }).then((response) => {
                    return response.json()
                }).then((data) => {
                    if (data['ok'] == 1) {
                        this.$emit("needRender")
                        this.cmShow = false
                    }
                })
            } else {
                this.cmShow = false
            }
        },
        createNewDir() {
            const dir_name = this.$refs.dir_name.value
            if (dir_name == '') {
                this.invalid.push('dir_name')
                return
            }
            this.invalid = []
            fetch(this.create_dir, {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-type": "application/json"
                },
                body: JSON.stringify({
                    "path": this.path + dir_name
                })
            }).then((response) => {
                return response.json()
            }).then((data) => {
                if (data['ok'] == 1) {
                    this.$emit("needRender")
                    this.showNewDir = false
                }
            })
        },
        toNewDir(add_path) {
            if (add_path == '../') {
                this.path = this.path.split("/").slice(0, -2).join('/') + '/'
            } else {
                this.path += add_path + "/"
            }

            fetch(this.get_dir + new URLSearchParams({ "path": this.path }), {
                credentials: "include",
                headers: {
                    "Content-type": "application/x-www-form-urlencoded;",
                    "Cookie": document.cookie
                }
            }).then((response) => {
                return response.json()
            }).then((data) => {
                this.dirs = data["dirs"]
                this.files = data["files"]
            })
        },
        UploadFile() {
            const form = document.querySelector('form')
            if (this.$refs.file.files.length == 0) {
                this.invalid.push('files')
                return
            }
            this.invalid = []
            const data = new FormData(form)
            data.append('path', this.path)
            fetch(form.action, {
                credentials: "include",
                method: form.method,
                body: data
            }).then((response) => {
                return response.json()
            }).then((data) => {
                if (data['ok'] == 1) {
                    this.$emit("needRender")
                }
            })
        }
    },
    mounted() {
        fetch(this.get_dir + new URLSearchParams({ "path": this.path }), {
            credentials: "include",
            headers: {
                "Content-type": "application/x-www-form-urlencoded;",
                "Cookie": document.cookie
            }
        }).then((response) => {
            return response.json()
        }).then((data) => {
            this.dirs = data["dirs"]
            this.files = data["files"]
        })
    }
}
</script>

<style scoped>
.custom-menu {
    z-index: 1000;
    position: absolute;
    overflow: hidden;
    border: 1px solid #CCC;
    white-space: nowrap;
    font-family: sans-serif;
    background: #FFF;
    color: #333;
    border-radius: 5px;
    padding: 0;
}

/* Each of the items in the list */
.custom-menu li {
    padding: 8px 12px;
    cursor: pointer;
    list-style-type: none;
    transition: all .3s ease;
    user-select: none;
}

.custom-menu li:hover {
    background-color: #DEF;
}
</style>